export const LIMIT = 20
export const PAGE = 1
export const STATUS_DEFAULT = 'ALL'
export const EDITABLE = 'EDITABLE'
export const DOWNLOAD = 'DOWNLOAD'
